import { FormItemTypes, IDictionary } from '@bimser/core';
import { Map } from 'immutable';
import { RuleEngineEntities } from '../../../../BCRuleManager';
import { LayoutDataItem } from '../../../common/entities';

export const removeItemFromRuleManager = (data: Map<string, LayoutDataItem>, id: string) => {
	const form = data.find(
		control => control.properties.get('controlType') === FormItemTypes.EContainerTypes.Form
	);

	const rules: IDictionary<RuleEngineEntities.IRule> = form.properties.get('rules') || {};
	const newRules: IDictionary<RuleEngineEntities.IRule> = {};

	for (const ruleId in rules) {
		for (const actionId in rules[ruleId].actions) {
			const action = rules[ruleId].actions[
				actionId
			] as RuleEngineEntities.IValueAssignActionWithSelection;
			if (action.selectedField?.name === id) {
				(
					rules[ruleId].actions[
						actionId
					] as RuleEngineEntities.IValueAssignActionWithSelection
				).selectedField = {
					name: '',
					propertyName: '',
					type: null,
					enumMembers: []
				};
			}

			if (action.field?.name === id) {
				(
					rules[ruleId].actions[
						actionId
					] as RuleEngineEntities.IValueAssignActionWithSelection
				).field = {
					name: '',
					propertyName: '',
					type: null,
					enumMembers: []
				};
			}
		}

		newRules[ruleId] = {
			...rules[ruleId],
			triggerEvents: rules[ruleId].triggerEvents.filter(
				(triggerEvent: string) => triggerEvent.split('.').at(0) !== id
			),
			actions: rules[ruleId].actions
		};
	}

	return data.setIn([form.id, 'properties', 'rules'], newRules);
};
